import Datacheck from './Datacheck';

export default Datacheck;
